module.exports = __webpack_public_path__ + "img/remove.d5929e61.svg";